var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      staticClass: "comment-form pb-2 pt-4 h-auto",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.handleCommentSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c(
            "b-col",
            { attrs: { cols: "11" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "my-auto", attrs: { sm: "1", cols: "2" } },
                    [
                      _c(
                        "profile-avatar",
                        _vm._b(
                          {
                            staticClass: "img-fluid rounded-circle sm",
                            attrs: { "avatar-options": { inline: false } },
                          },
                          "profile-avatar",
                          Object.assign({}, _vm.CURRENT_USER_DETAILS),
                          false
                        )
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "my-auto d-flex flex-row",
                      attrs: { sm: "11", cols: "10" },
                    },
                    [
                      _c("b-input", {
                        staticClass: "form-control form required comment",
                        attrs: {
                          id: "comment",
                          type: "text",
                          name: "comment",
                          placeholder: _vm.placeholder,
                        },
                        model: {
                          value: _vm.comment,
                          callback: function ($$v) {
                            _vm.comment = $$v
                          },
                          expression: "comment",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "d-none", attrs: { for: "comment" } },
                        [_vm._v(_vm._s(_vm.$t("global.words.comment")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-2 align-self-center",
                          attrs: {
                            type: "submit",
                            variant: "link",
                            disabled: _vm.$v.$invalid,
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("global.words.send")) +
                              "\n            "
                          ),
                          _c("icon", {
                            staticClass: "paper-comment text-primary",
                            attrs: { name: "paper-plane" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }